"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChariotProvider = void 0;
var Chariot_1 = require("../../Chariot");
var react_1 = require("./");
var react_2 = require("react");
var ChariotProvider = function (props) {
    var children = props.children, chariotInitialization = __rest(props, ["children"]);
    var _a = (0, react_2.useState)(null), chariot = _a[0], setChariot = _a[1];
    (0, react_2.useEffect)(function () {
        setChariot(new Chariot_1.default(chariotInitialization));
    }, [JSON.stringify(chariotInitialization)]);
    return chariot !== null ? (0, react_2.createElement)(react_1.ChariotContext.Provider, { value: chariot }, children) : null;
};
exports.ChariotProvider = ChariotProvider;
